module.exports = __webpack_public_path__ + "img/emtpy.159f240f.png";